<div class="relative w-full ">
  <!-- Bouton d'affichage -->
  <button #dateTimePickerButton
    type="button"
    [disabled]="disabled"
    class="px-3 py-1 flex justify-between items-center w-full disabled:opacity-50 disabled:cursor-not-allowed"
    (click)="onButtonClick()">

    <div class="text-left w-full px-1">
      <ng-container *ngIf="selectedDateTime; else noDate">
        <section class="flex justify-between items-center w-full">
          <span class="text-gray-500 text-l  font-medium">{{ formattedDate }} </span>
          <span class="font-bold text-gray-500 text-l">&#64; {{ formattedTime }}</span>
        </section>
      </ng-container>
      <ng-template #noDate>
        <span class="text-gray-400">{{ 'select-date-time' | translate }}</span>
      </ng-template>
    </div>
    <span class="flex items-center gap-2 ml-[10%]">
      <!-- Le champ affiche l'heure du LECTEUR ; l'icone dit de quel site il s'agit. -->
      @if (siteTimeZone) {
      <app-timezone-icon [iana]="siteTimeZone"></app-timezone-icon>
      }
      <i class="fa-solid fa-calendar-days text-[1.4em] text-blue-500"></i>
    </span>
  </button>
</div>

<!-- Template du popup (sera projeté dans l'overlay) -->
<ng-template #popupTemplate>
  <div class="p-4 bg-white border rounded-lg shadow-xl w-[600px] relative "
    (click)="$event.stopPropagation()">

    <!-- En-tête avec bouton de fermeture X -->

    <button type="button"
      class=" absolute top-0 right-0 bg-red-200 hover:bg-red-700  text-gray-500 hover:text-gray-100 text-xl py-0 px-2 border border-gray-200 rounded"
      (click)="closePopup()">
      <i class="fa-solid fa-times"></i>
    </button>


    <div class="flex gap-2">
      <!-- Calendrier (gauche) -->
      <div class="flex-1">
        <!-- Navigation mois/année -->
        <div class="flex justify-between items-center mb-3">
          <button type="button" class="p-1" (click)="prevMonth()">←</button>
          <div class="font-semibold">
            {{ monthName | translate }} - {{ currentMonthAndYear() | date:'yyyy' }}
          </div>
          <button type="button" class="p-1" (click)="nextMonth()">→</button>
        </div>

        <!-- Grille des jours -->
        <div class="grid grid-cols-7 gap-0 text-center text-sm p-0 m-0">
          <div class="font-medium text-gray-500">{{ 'components.calendar.abbrev-monday' | translate }}</div>
          <div class="font-medium text-gray-500">{{ 'components.calendar.abbrev-tuesday' | translate }}</div>
          <div class="font-medium text-gray-500">{{ 'components.calendar.abbrev-wednesday' | translate }}</div>
          <div class="font-medium text-gray-500">{{ 'components.calendar.abbrev-thursday' | translate }}</div>
          <div class="font-medium text-gray-500">{{ 'components.calendar.abbrev-friday' | translate }}</div>
          <div class="font-medium text-gray-500">{{ 'components.calendar.abbrev-saturday' | translate }}</div>
          <div class="font-medium text-gray-500">{{ 'components.calendar.abbrev-sunday' | translate }}</div>

          <ng-container *ngFor="let day of calendar">
            <button type="button"
              *ngIf="day; else blank"
              class="p-0 py-1 m-0 -ml-2 hover:bg-blue-100 rounded"
              [class.bg-blue-700]="selectedDateTime && selectedDateTime.getDate() === day && selectedDateTime.getMonth() === viewMonth() && selectedDateTime.getFullYear() === viewYear()"
              [class.text-white]="selectedDateTime && selectedDateTime.getDate() === day && selectedDateTime.getMonth() === viewMonth() && selectedDateTime.getFullYear() === viewYear()"
              [class.font-bold]="selectedDateTime && selectedDateTime.getDate() === day && selectedDateTime.getMonth() === viewMonth() && selectedDateTime.getFullYear() === viewYear()"
              (click)="selectDay(day)">
              {{ day }}
            </button>
            <ng-template #blank>
              <div></div>
            </ng-template>
          </ng-container>
        </div>
      </div>

      <!-- Sélecteur Heure / Minutes (droite) -->
      <div class="w-48 border-l pl-4 flex flex-col justify-between">
        <div>
          <div class="text-lg font-semibold mb-2 text-center">{{ 'Time' | translate }}</div>
          <div class="flex items-center justify-center space-x-1 mt-10 ">
            <!-- Heure -->
            <div class="flex flex-col items-center">
              <button type="button" (click)="incrementHour()" class="text-gray-500 hover:text-gray-700">
                <i class="fa-solid fa-chevron-up"></i>
              </button>
              <span class="inline-flex items-center">
                <input type="text"
                  [value]="(hour() | number:'2.0-0')"
                  (input)="onHourInput($event)"
                  class="w-[4.2rem] text-5xl rounded -px-1 m-0 text-center" />
                <span class="-ml-[4px]">h</span>
              </span>
              <button type="button" (click)="decrementHour()" class="text-gray-500 hover:text-gray-700">
                <i class="fa-solid fa-chevron-down"></i>
              </button>
            </div>

            <!-- Minute -->
            <div class="flex flex-col items-center">
              <button type="button" (click)="incrementMinute()" class="text-gray-500 hover:text-gray-700">
                <i class="fa-solid fa-chevron-up"></i>
              </button>
              <span class="inline-flex items-center relative">
                <input type="text"
                  [value]="(minute() | number:'2.0-0')"
                  (input)="onMinuteInput($event)"
                  class="w-[4.2rem] text-5xl rounded -px-1 m-0 text-center" />
                <span *ngIf="timeFormat=='24h'" class="-ml-[4px]">min</span>
              </span>
              <button type="button" (click)="decrementMinute()" class="text-gray-500 hover:text-gray-700">
                <i class="fa-solid fa-chevron-down"></i>
              </button>
            </div>

            <!-- AM/PM si format 12h -->
            <ng-container *ngIf="timeFormat === '12h'">
              <select [(ngModel)]="ampm" (ngModelChange)="onTimeChange()" class="border rounded px-0 py-1">
                <option value="AM">AM</option>
                <option value="PM">PM</option>
              </select>
            </ng-container>
          </div>
        </div>
      </div>
    </div>

    <!-- Boutons rapides -->
    <div class="flex justify-between mt-4 pt-2 border-t">
      <button type="button"
        class="px-3 py-1 bg-gray-200 text-gray-800 rounded hover:bg-gray-300 flex items-center gap-2"
        (click)="clear()"
        title="{{ 'clear' | translate }}">
        <i class="fa-regular fa-trash-can"></i>
        <span>{{ 'clear' | translate }}</span>
      </button>
      <button type="button"
        class="px-3 py-1 bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center gap-2"
        (click)="setNow()"
        title="{{ 'now' | translate }}">
        <i class="fa-regular fa-clock"></i>
        <span>{{ 'now' | translate }}</span>
      </button>
    </div>

  </div>
</ng-template>